import React from 'react';
import { CHIRP_UNIVERSAL_LINK } from '../../config';
import RequestAccessButton from '../RequestAccessButton';

interface AccessRequestOptionsProps {
  accessPointId: number | string;
  accessPointName: string;
  anonymousUserId: string;
  onShareSuccess: () => any;
  propertyName: string;
  supportPhoneNumber?: string | null;
  isVirtualDirectoryEnabled: boolean;
}

export const AccessRequestOptions: React.FC<AccessRequestOptionsProps> = (props) => {
  const {
    accessPointId,
    accessPointName,
    anonymousUserId,
    onShareSuccess,
    propertyName,
    supportPhoneNumber,
    isVirtualDirectoryEnabled,
  } = props;

  const requestAccessUrl = `${CHIRP_UNIVERSAL_LINK}/entry/${accessPointId}?a=${anonymousUserId}`;

  return (
    <div>
      <RequestAccessButton
        propertyName={propertyName}
        supportPhoneNumber={supportPhoneNumber}
        requestAccessUrl={requestAccessUrl}
        accessPointName={accessPointName}
        onSuccess={onShareSuccess}
        isVirtualDirectoryEnabled={isVirtualDirectoryEnabled}
        // @ts-ignore
        onError={(shareError: Error) => {
          // @TODO: Handle errors
          /* tslint:disable-next-line no-console */
          console.error(shareError);
        }}
      />
    </div>
  );
};

export default AccessRequestOptions;
